<template>
  <div v-editable="item && !blok.isGlobal" class="relative bg-white p-7">
    <component
      :is="item.url ? 'a' : 'div'"
      :href="item.url || null"
      class="group h-full"
      :class="{
        'flex flex-col gap-4 sm:gap-8': blok.style === 'cards',
      }"
    >
      <p
        class="pr-6 text-lg leading-6 font-bold sm:pr-0"
        :class="textColorClass(blok.iconTitleVariant, blok.bgVariant)"
      >
        {{ item.title }}
      </p>

      <div
        v-if="item.icon && item.icon.selectedIcon"
        class="order-first flex grow sm:order-none sm:justify-center"
        :class="{
          relative: blok.style === 'cards',
          'absolute h-12 w-12': blok.style !== 'cards',
        }"
      >
        <RawSvgIcon
          :svg="item.icon"
          :color="blok.iconColor"
          :classes="
            blok.style === 'cards'
              ? iconSize === 'large'
                ? 'h-14 w-14 sm:h-20 sm:w-20'
                : 'h-11 w-11'
              : 'w-11 h-11 md:w-12 md:h-12'
          "
        />

        <span
          v-if="item.displayVacanciesCounter && siteVacanciesTotal"
          class="font-bolder absolute -top-4 right-8 flex h-11 w-11 items-center justify-center rounded-full bg-black align-middle text-lg text-white"
          >{{ siteVacanciesTotal }}</span
        >
      </div>
      <RichText
        :blok="blok"
        :rich-text-content="item.textContent"
        class="order-first grow pr-6 text-sm leading-relaxed sm:order-none sm:pr-0"
      />

      <ArrowRightIcon
        v-if="item.url"
        aria-hidden="true"
        class="absolute right-4 bottom-7 h-6 w-6 motion-safe:group-hover:animate-bounce motion-safe:group-focus:animate-bounce sm:static"
      />
    </component>
  </div>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '../store'
import RawSvgIcon from './RawSvgIcon.vue'
import RichText from './RichText.vue'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
})

const store = useMainStore()
const { textColorClass } = useColorPalette()

const { siteVacanciesTotal } = storeToRefs(store)

const iconSize = computed(() => props.blok.iconSize || 'large')

onBeforeMount(() => {
  if (props.item.displayVacanciesCounter) {
    // We add a bit of time before making the request in case there's also a VacancyList block
    // in the page
    setTimeout(() => {
      store.getTotalSiteVacancies()
    }, 1200)
  }
})
</script>
